<template>
  <div v-if="loading">
    <div class="row">
      <div class="col-12">
        <label class="font28 font500"
          ><mdb-icon icon="cogs" /> จัดการเครดิต</label
        >
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-md-12">
        <!-- <div class="d-flex flex-row mr-5"> -->
        <div class="row">
          <div class="align-self-center ml-3">ค้นหา User</div>
          <div class="col-12 col-md-4 p-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon">
                  <mdb-icon far icon="edit" />
                </span>
              </div>
              <input
                id="filterInput"
                type="search"
                class="form-control"
                v-model="searchQuery"
                placeholder=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div>
      <mdb-datatable
        :arrows="true"
        :data="filteredPhotoFeed"
        striped
        bordered
        :searching="false"
        scrollY
        maxHeight="450px"
      />
    </div> -->

    <div>
      <mdb-tbl
        striped
        bordered
        :searching="false"
        scrollY
        maxHeight="450px"
        :arrows="true"
      >
        <mdb-tbl-head>
          <tr class="table-header table-sm">
            <th>{{ data.columns[0].label }}</th>
            <th>ยูสเซอร์เนม</th>
            <th>ชื่อผู้ใช้</th>
            <th>จำนวนเครดิต</th>
            <th>เติมเงิน</th>
            <th>ถอนเงิน</th>
            <th>ยืนยันการทำรายการ</th>
          </tr>
        </mdb-tbl-head>

        <mdb-tbl-body>
          <tr v-for="(item, index) in filteredPhotoFeed.rows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.username }}</td>
            <td>{{ item.full_name }}</td>
            <td class="text-left">
              <div class="rows" v-if="item.credit === 0">
                {{ currencyFormat(0) }}
              </div>
              <div class="rows" v-else>{{ currencyFormat(item.credit) }}</div>
            </td>
            <td>
              <div class="rows" style="min-width:100px;">
                <select
                  class="custom-select custom-select-sm"
                  :id="'deposit' + item.id"
                  @change="Setdata"
                >
                  <option value="null" name="deposit">เลือกแพ็กเกจ</option>
                  <option
                    v-for="(item, index) in promotion"
                    :key="index"
                    :value="item.pro_price"
                    name="deposit"
                  >
                    {{ item.pro_price }}
                  </option>
                </select>
              </div>
            </td>
            <td>
              <div class="rows" style="min-width:130px;">
                <input
                  type="text"
                  :id="'withdraw' + item.id"
                  name="withdraw"
                  class="form-control form-control-sm"
                  style="min-width:100px;"
                  width="100%"
                  @change="changData(item.id)"
                />
              </div>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-save color_white font12 btn_save"
                :dataid="item.id"
                @click="submitData(item.id)"
              >
                <i class="fas fa-save"></i> บันทึกข้อมูล
              </button>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>
    <mdb-container>
      <!-- <mdb-btn color="primary" @click.native="showModal = true">Launch modal</mdb-btn> -->
      <mdb-modal
        :show="showModal"
        @close="showModal = false"
        scrollable
        centered
      >
        <mdb-modal-header>
          <mdb-modal-title>
            <mdb-icon icon="fingerprint" /> แก้ไขข้อมูล</mdb-modal-title
          >
        </mdb-modal-header>
        <mdb-modal-body>
          <div class="row justify-content-center">
            <div class="col-10 col-md-9">
              <div class="row justify-content-center mt-3">
                <div class="col-5 align-self-center">ชื่อผู้ใช้</div>
                <div class="col-7 pl-0">
                  <input
                    type="text"
                    id="username"
                    v-model="full_name"
                    class="form-control form-control-sm"
                    width="100%"
                  />
                </div>
              </div>
              <div class="row justify-content-center mt-3">
                <div class="col-5 align-self-center">วันที่สมัคร</div>
                <div class="col-7 pl-0">{{ date_regis }}</div>
              </div>
              <div class="row justify-content-center">
                <div class="col-5 align-self-center">สถานะ</div>
                <div class="col-2 pl-0">
                  <label class="switch">
                    <input type="checkbox" v-model="status_user" />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="col-5 align-self-center pl-0">ปิด - เปิด</div>
              </div>
              <div class="row justify-content-center">
                <div class="col-12 text-center my-4">
                  <button
                    type="button"
                    class="btn btn-search color_white mr-3 font12"
                    style="font-weight:400;"
                    @click="edituser()"
                  >
                    บันทึก
                  </button>
                  <button
                    type="button"
                    class="btn btn-cancel color_white font12"
                    style="font-weight:400;"
                    @click="editusercancle()"
                  >
                    ยกเลิก
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mdb-modal-body>
      </mdb-modal>
    </mdb-container>
  </div>
</template>

<script>
import $ from "jquery";
// import {mdbDatatable} from 'mdbvue'
//import moment from 'moment'
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Managecredit",
  components: {
    // mdbDatatable,
  },
  data() {
    return {
      loading: false,
      showModal: false,
      searchTxt: "",
      full_name: "",
      date_regis: "",
      status_user: "",
      idedituser: 0,
      promotion: "",
      searchQuery: null,
      withdraw: 0,
      datapackage: "",
      data: {
        columns: [
          {
            label: "#",
            field: "id2",
            sort: true,
          },
          {
            label: "ชื่อผู้ใช้",
            field: "full_name",
            sort: true,
          },
          {
            label: "จำนวนเครดิต",
            field: "credit",
            sort: true,
            format: (value) => {
              if (value == "-") {
                return '<div class="rows">' + this.currencyFormat(0) + "</div>";
              } else {
                return (
                  '<div class="rows">' + this.currencyFormat(value) + "</div>"
                );
              }
            },
          },
          // {
          // 	label: 'เติมเงิน',
          // 	field: 'id',
          // 	sort: true,
          // 	format: (value) => {
          // 		if (value) {
          // 			return '<div class="rows"><input type="text" id="deposit' + value + '" name="deposit" class="form-control form-control-sm" style="min-width:100px;" /></div>'
          // 		}
          // 	},
          // },
          {
            label: "เติมเงิน",
            field: "id",
            sort: true,
            format: (value) => {
              let html = "";
              for (const item of this.promotion) {
                html +=
                  '<option value="' +
                  item.pro_price +
                  '" name="deposit">' +
                  item.pro_price +
                  "</option>";
              }
              if (value) {
                return (
                  '<div class="rows" style="min-width:100px;"><select class="custom-select custom-select-sm" id="deposit' +
                  value +
                  '"><option value="null" selected  name="deposit">เลือกแพ็กเกจ</option>' +
                  html +
                  "</select></div>"
                );
              }
            },
          },
          {
            label: "ถอนเงิน",
            field: "id",
            sort: true,
            format: (value) => {
              if (value) {
                return (
                  '<div class="rows" style="min-width:130px;"><input type="text" id="withdraw' +
                  value +
                  '" name="withdraw" class="form-control form-control-sm" style="min-width:100px;" width="100%" /></div>'
                );
              }
            },
          },
          {
            label: "ยืนยันการทำรายการ",
            field: "id",
            sort: true,
            format: (value) => {
              if (value) {
                return (
                  '<button type="button" class="btn btn-save color_white font12 btn_save" dataid="' +
                  value +
                  '"><i class="fas fa-save"></i> บันทึกข้อมูล</button>'
                );
              }
            },
          },
        ],
        rows: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      token: "token",
    }),
    // eslint-disable-next-line vue/return-in-computed-property
    filteredPhotoFeed() {
      if (this.data) {
        const searchQuery = this.searchQuery;

        if (!searchQuery) {
          return this.data;
        }
        let columstable = this.data.columns;
        // eslint-disable-next-line vue/return-in-computed-property
        // eslint-disable-next-line no-unused-vars
        const searchString = searchQuery.trim().toLowerCase();
        // eslint-disable-next-line array-callback-return
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        const rownsdata = this.data.rows.filter((item) => {
          if (item.username.toLowerCase().indexOf(searchString) !== -1) {
            return item;
          }
        });
        let sumdata;
        sumdata = { columns: columstable, rows: rownsdata };
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return sumdata;
      }
    },
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      loadsession: "loadsession",
      callApiMotherFucker: "callApiMotherFucker",
    }),
    currencyFormat(n) {
      n = parseFloat(n);
      return n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    Savedata2() {
      if (this.deposit != "" && this.withdraw != "") {
        return this.$swal({
          html:
            '<i class="fa fa-coins fa-6x"></i><br><br>กรุณากรอกชื่อผู้ใช้<br>',
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
      this.callApiMotherFucker({
        method: "post",
        path: "/update_member",
        data: {
          id: this.idedituser,
          full_name: this.full_name,
          status: this.status_user == true ? 1 : 0,
        }, // this.status_user ถ้าเป็น 1 คือ true , ถ้าเป็น 0 คือ false
      }).then((res) => {
        console.log("payload", res.payload);
        if (res.code == 0) {
          this.$swal({
            icon: "success",
            html: res.msg,
            timer: 8000,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          setTimeout(() => {
            location.reload();
          }, 2000);
        } else {
          this.$swal({
            icon: "error",
            html: res.msg,
            timer: 8000,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      });
    },
    async Search() {
      this.loading = false;
      if (this.searchTxt == "") {
        await this.callApiMotherFucker({
          method: "post",
          path: "/list_member/query",
          data: {},
        }).then((res) => {
          if (res.payload) {
            this.data.rows = this.$add_index(res.payload);
            this.loading = true;
          }
        });
      } else {
        await this.callApiMotherFucker({
          method: "post",
          path: "/list_member/query",
          data: {},
        }).then((res) => {
          if (res.payload) {
            this.data.rows = this.$add_index(res.payload);
          }
        });
        console.log(this.searchTxt);
        this.data.rows = this.data.rows.filter((val) => {
          if (val.username.search(this.searchTxt) >= 0) {
            return true;
          } else {
            return false;
          }
        });
        this.loading = true;
      }
    },
    Setdata(e) {
      const theTarget = e.target.options[e.target.options.selectedIndex].value;
      this.datapackage = parseInt(theTarget);
    },
    changData(dataid) {
      if ($("#withdraw" + dataid).val() === "") {
        this.withdraw = 0;
      } else {
        this.withdraw = $("#withdraw" + dataid).val();
      }
    },
    submitData(dataid) {
      let ieieie = this;
      let id = dataid;
      // eslint-disable-next-line no-unused-vars
      let deposit = 0;
      // eslint-disable-next-line no-unused-vars
      let withdraw = this.withdraw;
      deposit = $("#deposit" + id + " option:selected").text();
      // withdraw = $("#withdraw" + id).val();
      if (deposit == "เลือกแพ็กเกจ" && withdraw === 0) {
        return ieieie.$swal({
          html:
            '<i class="fa fa-coins fa-6x"></i><br><br>กรุณาเลือกการเติมเงิน หรือกรอกข้อมูลถอนเงิน<br>',
          timer: false,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else if (deposit != "เลือกแพ็กเกจ" && withdraw !== 0) {
        return ieieie.$swal({
          html:
            '<i class="fa fa-coins fa-6x"></i><br><br>กรุณาเลือกการเติมเงิน หรือถอนเงินเพียงอย่างเดียว<br>',
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else if (deposit != "เลือกแพ็กเกจ" && withdraw === 0) {
        ieieie
          .callApiMotherFucker({
            method: "post",
            path: "/add_credit/DEPOSIT",
            data: { id: id, amount: deposit },
          })
          .then((res) => {
            console.log("payload", res.payload);
            if (res.code == 0) {
              ieieie
                .$swal({
                  icon: "success",
                  html: res.msg,
                  timer: 8000,
                  showConfirmButton: true,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                })
                .then((result) => {
                  if (result) {
                    location.reload();
                  }
                });
            } else {
              ieieie.$swal({
                icon: "error",
                html: res.msg,
                timer: false,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            }
          });
      } else if (deposit == "เลือกแพ็กเกจ" && withdraw.length > 0) {
        ieieie
          .callApiMotherFucker({
            method: "post",
            path: "/add_credit/WITHDRAW",
            data: { id: id, amount: withdraw },
          })
          .then((res) => {
            console.log("payload", res.payload);
            if (res.code == 0) {
              ieieie
                .$swal({
                  icon: "success",
                  html: res.msg,
                  timer: false,
                  showConfirmButton: true,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                })
                .then((result) => {
                  if (result) {
                    location.reload();
                  }
                });
            } else {
              ieieie.$swal({
                icon: "error",
                html: res.msg,
                timer: 8000,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            }
          });
      }
    },
  },

  async mounted() {
    await this.callApiMotherFucker({
      method: "post",
      path: "/list_member/All",
      data: {},
    }).then((res) => {
      this.loading = true;
      if (res.payload) {
        this.data.rows = this.$add_index(res.payload);
      }
    });
    await this.callApiMotherFucker({
      method: "GET",
      path: "/promotionAll",
      data: {},
    }).then((res) => {
      this.loading = true;
      if (res.payload) {
        this.promotion = res.payload;
        console.log("this.promotion", this.promotion);
      }
    });
  },
};
</script>
<style scoped>
.fa-13 {
  font-size: 1em;
}
.field-icon {
  margin-left: 25px;
  margin-right: 10px;
  margin-top: 0px;
  position: relative;
  z-index: 2;
}

.label1 {
  color: red !important;
}
.modal-dialog .modal-content .modal-header {
  border-top-left-radius: 0.1rem !important;
  border-top-right-radius: 0.1rem !important;
  background-color: #f5904b !important;
  color: #ffffff;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  margin-top: 15px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #02bf4e;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
